import { IContentSection } from '../interfaces/card-info.interface';

// Long-form SEO content for the home page (/), grouped by insertion point.
// Headings use the site convention: lowercase with <span class="gradient-text"> accents.
// Brand names and acronyms (SEMNexus, ASO, AEO, AI) keep their casing.

// Band 1: immediately below the "why semnexus" block.
export const LANDING_INTRO: IContentSection[] = [
  {
    headingHtml: 'mobile app development & <span class="gradient-text">marketing agency</span>',
    lead: [
      'SEMNexus is a full-service mobile app development and marketing agency helping startups, entrepreneurs, and established businesses launch, scale, and optimize digital products. Our team combines custom app development, App Store Optimization (ASO), mobile app marketing, answer engine optimization (AEO), user acquisition, influencer marketing, and AI development services under one roof.',
    ],
    outro: [
      'Unlike traditional agencies that focus on either development or marketing, SEMNexus supports the entire product lifecycle. From idea validation and MVP development to App Store growth, user acquisition, retention, and revenue optimization, we help companies build products designed for long-term success.',
    ],
  },
];

// Band 2: directly above the services section.
export const LANDING_PRE_SERVICES: IContentSection[] = [
  {
    headingHtml: 'end-to-end <span class="gradient-text">app growth</span> solutions',
    lead: [
      'Building an app is only the beginning.',
      'Many applications fail not because of poor products but because of weak distribution, ineffective marketing, or a lack of product-market fit. SEMNexus combines development, marketing, analytics, and growth strategy to help businesses build sustainable growth systems rather than isolated campaigns.',
      'Our services include:',
    ],
    bullets: [
      'Mobile App Development',
      'AI App Development',
      'App Store Optimization',
      'Mobile App Marketing',
      'User Acquisition',
      'Answer Engine Optimization',
      'Influencer Marketing',
      'Website Marketing',
      'Conversion Optimization',
      'Growth Strategy',
    ],
  },
];

// Band 2: after the services section, expanding the development and marketing offerings,
// then AEO and the "why businesses choose us" lead-in, before case studies.
export const LANDING_POST_SERVICES: IContentSection[] = [
  {
    headingHtml: 'custom mobile<br><span class="gradient-text">app development</span>',
    lead: [
      'Our mobile app development team builds custom iOS, Android, cross-platform, SaaS, AI-powered, and web applications designed for scalability and performance. Whether you are launching a startup MVP or modernizing an existing platform, our developers create secure, maintainable software that aligns with your business objectives.',
      'Services include:',
    ],
    bullets: [
      'iOS App Development',
      'Android App Development',
      'React Native Development',
      'AI App Development',
      'SaaS Development',
      'Web Application Development',
      'UI/UX Design',
      'API Development',
    ],
  },
  {
    headingHtml: 'mobile app<br><span class="gradient-text">marketing</span><br>services',
    lead: [
      'Successful applications require more than downloads. They require a repeatable growth engine.',
      'Our app marketing services focus on acquiring high-quality users through App Store Optimization, paid advertising, influencer marketing, creative production, conversion optimization, and retention marketing. We help businesses increase visibility, improve App Store rankings, reduce acquisition costs, and maximize lifetime value.',
      'Services include:',
    ],
    bullets: [
      'App Store Optimization (ASO)',
      'Apple Search Ads',
      'Google App Campaigns',
      'TikTok Advertising',
      'Meta Advertising',
      'Influencer Marketing',
      'Mobile User Acquisition',
      'Retention Marketing',
    ],
  },
  {
    headingHtml: 'answer engine<br><span class="gradient-text">optimization</span><br>(AEO)',
    lead: [
      'Search is evolving beyond traditional search engines.',
      'AI platforms such as ChatGPT, Gemini, Claude, Perplexity, and Google AI Overviews increasingly influence purchasing decisions and vendor discovery. Our Answer Engine Optimization services help businesses improve visibility within AI-generated recommendations through entity optimization, structured data implementation, authority building, citation development, and AI search strategy.',
    ],
    outro: [
      'Our goal is to help businesses become the trusted answer when users ask AI platforms for recommendations.',
    ],
  },
  {
    headingHtml: 'why businesses <span class="gradient-text">choose SEMNexus</span>',
    lead: [
      'SEMNexus combines technical development expertise with performance marketing execution. Our clients work with a single partner capable of designing, building, launching, marketing, and scaling digital products. This integrated approach reduces communication overhead, accelerates development timelines, and creates stronger alignment between product development and growth objectives.',
      'Businesses choose SEMNexus for:',
    ],
    bullets: [
      'Mobile App Development',
      'App Store Optimization',
      'User Acquisition',
      'AI Development',
      'Influencer Marketing',
      'Answer Engine Optimization',
      'Startup Product Strategy',
      'Growth Consulting',
    ],
  },
];

// Band 3: bottom SEO block, before the connect footer.
export const LANDING_BOTTOM: IContentSection[] = [
  {
    headingHtml: 'mobile app development, marketing, and <span class="gradient-text">growth experts</span>',
    lead: [
      'SEMNexus helps businesses build, launch, and scale mobile applications through a combination of app development, app marketing, App Store Optimization, Answer Engine Optimization, influencer marketing, and growth consulting. Whether you’re creating a new startup, expanding an existing product, or seeking greater visibility across traditional and AI-powered search platforms, our team provides the technical expertise and growth strategies required to compete in today’s digital marketplace.',
    ],
    outro: [
      'From MVP development and AI software engineering to mobile user acquisition and App Store growth, SEMNexus serves as a long-term partner focused on measurable business outcomes rather than isolated deliverables.',
    ],
  },
];
